<div class="cfa-navigation-wrapper">
  <cfa-toolbar    [appName]="appName"
    [mobileTitle]="getMobileTitle()"
    [cfaTabs]="cfaTabs"
    [cfaMenuItems]="cfaMenuItems"
    [showHamburgerMenu]="getMobileNavType() === 0"
    [userName]="userName"
    [activeSearchObject]="activeSearchObject"
    [searchObjects]="searchObjects"
    [navSearchObjectName]="navSearchObjectName"
    [navSearchFilterFunction]="navSearchFilterFunction"
    [showDropShadow]="showDropShadow"
    [useMaterialTheme]="useMaterialTheme"
    [ignoreContainerPadding]="ignoreContainerPadding"
    [showMenuPane]="showMenuPane"
    [cartEnabled]="cartEnabled"
    [menuPaneCalculatedDistance]='calculatedDistance'
    [customHeader]="customHeader"
    (homeClicked)="homeClicked()"
    (storeSelected)="selectedStoreChanged($event)"
    (signOutClicked)="signoutClicked()">

    @if (customHeader) {
      <cfa-nav-header>
        <ng-content select="cfa-nav-header"></ng-content>
      </cfa-nav-header>
    }

    <cfa-cart-button toolbarRight [icon]="cartIcon" [showCartTotal]="showCartTotal" [showCartBadge]="showCartBadge" [loading]="cartLoading"
    (click)="cartEnabled? cartClicked() : null" [class.invis]="!cartEnabled" id="cart-button"></cfa-cart-button>
  </cfa-toolbar>

  <ng-content #navBody select="cfa-nav-content"></ng-content>

  <ng-content></ng-content>

  @if (getMobileNavType() === 1) {
    <cfa-bottom-tab-container   [cfaTabs]="cfaTabs"
      [cfaMenuItems]="cfaMenuItems"
      [userName]="userName"
      [showDropShadow]="showDropShadow"
      [useMaterialTheme]="useMaterialTheme"
      (signOutClicked)="signoutClicked()"
      >
    </cfa-bottom-tab-container>
  }
</div>
